module.exports = __webpack_public_path__ + "img/57ed073.jpg";